import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";

const LINK_ELEMENT = "#xylect-link-view";
const OPTIONS_ELEMENT = "#xylect-option-view";
const TOGGLE_BUTTON = ".xylect-toggle-button";
const UNIT_BUTTON = ".xylect-unit-button";

export default class PumpProductPageDom extends DomElementsBase {
	constructor($module) {
		const selectors = [LINK_ELEMENT, OPTIONS_ELEMENT];

		super($module, selectors);

		this.elements = {
			linkViewElement: () => {
				return this.getElement(LINK_ELEMENT);
			},

			optionsViewElement: () => {
				return this.getElement(OPTIONS_ELEMENT);
			},

			toggleButtonElement: () => {
				return this.getElement(TOGGLE_BUTTON);
			},

			unitElement: () => {
				return this.getElement(UNIT_BUTTON);
			},
		};
	}
}
